var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"print"},[_c('MainColumn',{staticClass:"center"},[_c('Logo'),_vm._v(" "+_vm._s(_vm.$store.state.text)+" ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }